import type { HTMLAttributes, ReactNode } from "react";
import { useExploreInView } from "./useExploreInView";

type ExploreRevealProps = {
  children: ReactNode;
  className?: string;
  /** Stagger delay in ms when visible */
  delayMs?: number;
} & Omit<HTMLAttributes<HTMLDivElement>, "children" | "className">;

export function ExploreReveal({
  children,
  className = "",
  delayMs = 0,
  ...rest
}: ExploreRevealProps) {
  const { ref, isInView } = useExploreInView<HTMLDivElement>();

  return (
    <div
      ref={ref}
      className={`explore-reveal${isInView ? " is-visible" : ""} ${className}`.trim()}
      style={{
        transitionDelay: isInView ? `${delayMs}ms` : undefined,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
